import r from "stlite_lib.whl";
import t from "streamlit.whl";
const o = {
  // Vite resolves asset imports such as stlite_lib.whl and streamlit.whl above
  // to path-only URLs in the production build, e.g. "/assets/stlite_lib-0.1.0-py3-none-any.whl".
  // However, micropip treats such path-only URLs as local file URLs meaning "file:////assets/stlite_lib-0.1.0-py3-none-any.whl"
  // since 0.7.0 due to the change by https://github.com/pyodide/micropip/pull/145,
  // while we intend them to be remote URLs.
  // So we need to convert these path-only URLs to full URLs including the protocol explicitly.
  stliteLib: new URL(r, import.meta.url).href,
  streamlit: new URL(t, import.meta.url).href
};
export {
  o as wheelUrls
};
//# sourceMappingURL=vite-utils.js.map
